/**
 * 持久化存储参数
 */
import NativeStorage from "@/utils/nativeStorage/native_storage";
import {
  PRESISITE_APIIDS,
  PRESISITE_MOBILE_CONFIG_TS,
  PRESISITE_ENCRYPTION_KEY_ID,
  PRESISITE_ENCRYPTION_PUB_KEY,
  INS_API_MID
} from "@/utils/nativeStorage/local_keys";
import { creatUUid } from "../utils/index";

const defaultPubKey =
  "LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0KTUlJQklqQU5CZ2txaGtpRzl3MEJBUUVGQUFPQ0FROEFNSUlCQ2dLQ0FRRUFvb0dHYi9GV1daVTcveVp2LzdkQwpKbHlzRFVjRytzZVo1alNpS0g4MGlVVTJlMlB4YmprQlVkd1Z2bkNoSlBvdG9xcFIxdTJIcUI3MDhUSzJWaE5WClppMldhR0lSdlRkQ2I3aXZPWmdZSmc2RElsZCtFZmRPTDEyb2dITjVhNnhMM0F6NU5MUkVCNVFJcTlDNmdLYVAKRDNZQmZiZEVLL2lNVDhwS2EwODF1Qjd3Y3BrQmZYU1g4Z1NyVDJBOVVhdUs1UGlnZ3plUkwraEd0SzhNQk1yMwpWM3NuTmtOdFZnTEdjMlVIM3F3T3E0aFovbTlkMndvUklWd0JDTXZrR3BIUTltTGZVSE5iRDRPZVhkOGZXTTVWCjA3bVNYRXNVbWcxT1VGTE5YUXpYbWJSMnE4aDVFZXBKZUlXbnhHMnU1ejY4S1RoZmtaZWxWdWc3a0h5eHduTysKYndJREFRQUIKLS0tLS1FTkQgUFVCTElDIEtFWS0tLS0tCg==";
const defaultPubKeyId = "236";

class PresisiteAPIParams {
  private APIIds: any = null;
  private cg_api_mobileconfig_ts = "";
  private cg_api_password_encryption_key_id = "";
  private cg_api_password_encryption_pub_key = "";

  private INS_API_MID = "";

  public async getAPIId(key: string) {
    if (!this.APIIds) {
      await this.initAPIIds();
    }
    return this.APIIds[key];
  }

  public async getPubKey() {
    await this.initEncryptionPubKey();
    return this.cg_api_password_encryption_pub_key;
  }
  public async getKeyId() {
    await this.initEncryptionKeyId();
    return this.cg_api_password_encryption_key_id;
  }

  public async getConfigTs() {
    if (!this.cg_api_mobileconfig_ts) {
      await this.initConfigTs();
    }
    return this.cg_api_mobileconfig_ts;
  }

  public async initConfigTs() {
    this.cg_api_mobileconfig_ts = await NativeStorage.get(
      PRESISITE_MOBILE_CONFIG_TS
    );
  }

  public async getMid() {
    await this.initApiMid();
    return this.INS_API_MID;
  }

  public catchConfigTs(value: string) {
    this.cg_api_mobileconfig_ts = value;
    NativeStorage.set(PRESISITE_MOBILE_CONFIG_TS, this.cg_api_mobileconfig_ts);
  }
  public async initEncryptionKeyId() {
    if (!this.cg_api_password_encryption_key_id) {
      this.cg_api_password_encryption_key_id =
        (await NativeStorage.get(PRESISITE_ENCRYPTION_KEY_ID)) ||
        defaultPubKeyId;
    }
  }

  public catchEncryptionKeyId(value: string) {
    this.cg_api_password_encryption_key_id = value;
    NativeStorage.set(
      PRESISITE_ENCRYPTION_KEY_ID,
      this.cg_api_password_encryption_key_id
    );
  }

  public async initEncryptionPubKey() {
    if (!this.cg_api_password_encryption_pub_key) {
      this.cg_api_password_encryption_pub_key =
        (await NativeStorage.get(PRESISITE_ENCRYPTION_PUB_KEY)) ||
        defaultPubKey;
    }
  }

  public catchEncryptionPubKey(value: string) {
    this.cg_api_password_encryption_pub_key = value;
    NativeStorage.set(
      PRESISITE_ENCRYPTION_PUB_KEY,
      this.cg_api_password_encryption_pub_key
    );
  }
  public async initApiMid() {
    this.INS_API_MID = await NativeStorage.get(INS_API_MID);
  }

  public catchApiMid(value: string) {
    const newValue = value.replace(";", "");
    this.INS_API_MID = newValue;
    NativeStorage.set(INS_API_MID, this.INS_API_MID);
  }

  private async initAPIIds() {
    const presisiteAPIIds = await NativeStorage.get(PRESISITE_APIIDS);
    if (presisiteAPIIds) {
      this.APIIds = presisiteAPIIds;
      return;
    }
    this.APIIds = {
      cg_api_device_id: creatUUid(),
      cg_api_family_device_id: creatUUid(),
      cg_api_ad_id: creatUUid()
    };
    NativeStorage.set(PRESISITE_APIIDS, this.APIIds);
  }
}

export default new PresisiteAPIParams();
